export const maqueta = {
    text1: "Wykonano",
    text2: "Check-inów",
    text3: "Zaoszczędzonych kartek papieru 😊",
    text4: "Za każde 100 check-inów sadzimy drzewo z",
    text5: "ONE TREE PLANTED",
    text6: "Powiadomienia",
    text7: "Brak powiadomień",
    text8: "Zobacz wszystkie",
    text9: "Witamy",
    text10: "Firma",
    text11: "Wszystkie obiekty",
    text12: "Profil",
    text13: "Wyloguj się",
    text14: "Przepraszamy, podczas wylogowywania wystąpił błąd",
    text15: "Płatność za subskrypcję została odrzucona",
    text16: "Aby dalej korzystać z WACheckin, należy dokonać płatności",
    text17: "Informacje o check-in",
    text18: "Dane check-in",
    text19: "Data zgłoszenia:",
    text20: " o godz.",
    text21: "Dane zebrane podczas check-in gościa",
    text22: "Imię",
    text23: "Nazwisko",
    text24: "Telefon",
    text25: "Data pobytu",
    text26: "Typ dokumentu",
    text27: "Paszport",
    text28: "Dowód osobisty",
    text29: "Numer dokumentu",
    text30: "Informacje dodatkowe",
    text31: "Data ważności dokumentu",
    text32: "Narodowość",
    text33: "Data urodzenia",
    text34: "Płeć",
    text35: "Kobieta",
    text36: "Mężczyzna",
    text37: "Zamknij",
    text38: "Check-iny",
    text39: "Zamówienia usług",
    text40: "Obiekty",
    text41: "Sprzedaż dodatkowa",
    text42: "Integracje",
    text43: "Rozliczenia",

    // Corrections
    p1: "Rezerwacje",

    // Plan validation corrections
    p2: `Zmień plan na wyższy, aby wykonywać check-iny`,
    p3: `Niestety, dla tego obiektu nie ma obecnie aktywnej subskrypcji ani dostępnych środków.`,
    p4: `Zmień plan`,

    p5: `Check-in nie jest dostępny w tym obiekcie.`,
    p6: `Aby uzyskać więcej informacji, prosimy o kontakt z właścicielem obiektu.`,

    p7: `Konto niezweryfikowane`,
    p8: `Prosimy sprawdzić skrzynkę odbiorczą i potwierdzić konto. Wiadomość nie dotarła?`,
    p9: `Wyślij ponownie`,
    p10: `Wysyłanie wiadomości, proszę czekać...`,
    p11: `Moja subskrypcja`,

    p12: `Język i region`,
    p13: `Wybierz język i region`,
    p14: `Tutaj można zobaczyć wszystkie zrealizowane check-iny.`,
    p15: `Zaplanuj check-iny z wyprzedzeniem i wyślij je swoim gościom.`,
    p16: `Tutaj znajdują się zamówienia usług od gości, takie jak wypożyczenia, wycieczki i inne.`,
    p17: `Masowe wiadomości WhatsApp`,
    p18: `Połącz swoje konto WhatsApp Business z naszą platformą i uruchom masową wysyłkę spersonalizowanych wiadomości do gości, szybko i łatwo, bezpośrednio z oficjalnego numeru.`,
    p19: `Ta funkcja jest jeszcze w przygotowaniu.`,
    p20: `Informacje o check-in`,

    p21: `Informacje o check-in`,
    p22: `Powiązane check-iny`,
    p23: `Brak powiązanych check-inów.`,
    p24: `Więcej informacji:`,
    p25: `Którym obiektem chcesz zarządzać?`,
    p26: ``,
    p27: ``,
    p28: ``,
    p29: ``,
    p30: ``,
    p31: ``,
};
